import React, { useRef, useState } from 'react';
import GoogleMapReact from "google-map-react";
import DashboardIncidentMarker from './DashboardIncidentMarker';
import { useThemeMode } from '../../context/ThemeContext';
import { DARK_MAP_STYLE, LIGHT_MAP_STYLE } from '../../config/mapTheme';

// Announcements can have empty-string lat/lng (e.g. drills without a location set).
// Feeding those into LatLngBounds/markers produces invalid positions, so filter first.
function hasValidLocation(a) {
  return a.lat !== '' && a.lng !== '' && a.lat != null && a.lng != null
    && !Number.isNaN(Number(a.lat)) && !Number.isNaN(Number(a.lng));
}

function DashboardMap({ lat = 24.491241, lng = 54.37831961, details = "", announcements = [], height = "520px" }) {
  const { mode } = useThemeMode();

  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const locatedAnnouncements = announcements.filter(hasValidLocation);

  const [defaultProps] = useState({
    center: {
      lat: 24.491241,
      lng: 54.37831961,
    },
    zoom: 11,
    minZoom: 8 // Set a minimum zoom level
  });

  const handleApiLoaded = (map, maps) => {
    if (locatedAnnouncements.length === 0) return;

    const bounds = new maps.LatLngBounds();
    locatedAnnouncements.forEach((announcement) => {
      bounds.extend(new maps.LatLng(Number(announcement.lat), Number(announcement.lng)));
    });

    // Fit the map to the bounds
    map.fitBounds(bounds);

    const listener = maps.event.addListener(map, 'idle', () => {
      if (map.getZoom() > defaultProps.minZoom) {
        map.setZoom(defaultProps.minZoom);
      }
      maps.event.removeListener(listener);
    });
  };

  return (
    <div className="bg-white rounded-xl border border-neutral-200 shadow-subtle overflow-hidden relative h-full dark:bg-ink-900 dark:border-neutral-700">
      <div className="relative bg-[#eef3f7]" style={{ height, minHeight: '520px' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCI8O91FfQgfevadyNo9pKNt52MT5RZp_4" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          options={{ styles: mode === 'dark' ? DARK_MAP_STYLE : LIGHT_MAP_STYLE }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map;
            mapsRef.current = maps;
            handleApiLoaded(map, maps);
          }}
        >
          {locatedAnnouncements.map((announcement) => (
            <DashboardIncidentMarker
              key={announcement.id}
              lat={announcement.lat}
              lng={announcement.lng}
              announcement={announcement}
            />
          ))}
        </GoogleMapReact>

        {locatedAnnouncements.length === 0 && (
          <div className="absolute inset-0 flex items-center justify-center text-sm font-medium text-neutral-400 dark:text-neutral-500">
            No incident locations to display
          </div>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
